import React from "react";


export const ColourBlock: React.FC<{ colour: string }> = ({ colour }) => {
    return (
        // a circle with the colour as the background (this can be done with a radius)
        <div style={{ width: '100%', height: 20, borderRadius: 5, backgroundColor: colour }} />
    );
}